import { render, staticRenderFns } from "./MessageStatus.vue?vue&type=template&id=51f0231f&scoped=true&"
import script from "./MessageStatus.vue?vue&type=script&lang=js&"
export * from "./MessageStatus.vue?vue&type=script&lang=js&"
import style0 from "./MessageStatus.vue?vue&type=style&index=0&id=51f0231f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f0231f",
  null
  
)

export default component.exports